export function reattachCanvasHandlers(snapshot, handlers = {}) {
  const {
    onSwimlaneEdit,
    onSwimlaneResize,
    onNodeDelete,
    onNodeEdit,
    onRiskClick,
    onHexagonControlClick,
    onHexagonControlsOverflowClick,
    onEdgeDelete,
    onEdgeEdit,
    onEdgeWaypointsChange,
  } = handlers;

  const heightUpdates = {};
  const rawNodes = Array.isArray(snapshot?.nodes) ? snapshot.nodes : [];
  const rawEdges = Array.isArray(snapshot?.edges) ? snapshot.edges : [];

  const nodes = rawNodes.map((node) => {
    if (node.type === 'swimlane') {
      const actor = String(node.data?.actor || '').trim();
      const h = Number(node.data?.height);
      if (actor && Number.isFinite(h) && h > 0) {
        heightUpdates[actor] = h;
      }
      return {
        ...node,
        data: {
          ...node.data,
          onEdit: onSwimlaneEdit,
          onResize: onSwimlaneResize,
        },
      };
    }

    const nodeRisks = Array.isArray(node.data?.risks) ? node.data.risks : [];
    return {
      ...node,
      data: {
        ...node.data,
        onDelete: () => onNodeDelete?.(node.id),
        onEditNode: () => onNodeEdit?.(node.id),
        ...(nodeRisks.length > 0
          ? {
            onRiskClick: () => onRiskClick?.(node.id, nodeRisks),
            onHexagonControlClick: (control) => onHexagonControlClick?.(
              node.id,
              node.data?.nodeDescription,
              control,
              nodeRisks
            ),
            onHexagonControlsOverflowClick: (controls) => onHexagonControlsOverflowClick?.(
              node.id,
              node.data?.nodeDescription,
              controls,
              nodeRisks
            ),
          }
          : {}),
      },
    };
  });

  const edges = rawEdges.map((edge) => ({
    ...edge,
    data: {
      ...edge.data,
      onDelete: () => onEdgeDelete?.(edge.id),
      onEdit: () => onEdgeEdit?.(edge.id),
      onWaypointsChange: (wps) => onEdgeWaypointsChange?.(edge.id, wps),
    },
  }));

  return { nodes, edges, heightUpdates };
}
